const html = require('raw-loader!./../templatesPdfs/closeCashier.html')


class TemplateMountParams {
    title_value = ''
    enterprise_name = ''
    info_address = ''
    info_address2 = ''
    cep_value = ''
    cnpj_value = ''
    ie_value = ''
    doc_value = ''
    date_value = ''
    moviment_value = ''
    sangria_in_value = ''
    sangria_pdv_value = ''
    sangria_current_cashier_value = ''
    sangria_out_type_value = ''
    sangria_deservacao_value = ''
    money_value = ''
    func_response = ''
    note_title_value = ''
    value_open_cashier = ''
    value_bleed_cashier = ''
    value_close_cashier = ''

    hasItems = false
    static instance(content, hasItems = false) {

        let i = new TemplateMountParams()
        i.hasItems = hasItems
        i.note_title_value = content.note_title_value ? content.note_title_value : null
        i.title_value = content.title_value ? content.title_value : null
        i.enterprise_name = content.enterprise_name ? content.enterprise_name : null
        i.info_address = content.info_address ? content.info_address : null
        i.info_address2 = content.info_address2 ? content.info_address2 : null
        i.cep_value = content.cep_value ? content.cep_value : null
        i.cnpj_value = content.cnpj_value ? content.cnpj_value : null
        i.ie_value = content.ie_value ? content.ie_value : null
        i.doc_value = content.doc_value ? content.doc_value : null
        i.date_value = content.date_value ? content.date_value : null
        i.moviment_value = content.moviment_value ? content.moviment_value : null
        i.sangria_in_value = content.sangria_in_value ? content.sangria_in_value : null
        i.sangria_pdv_value = content.sangria_pdv_value ? content.sangria_pdv_value : null
        i.sangria_current_cashier_value = content.sangria_current_cashier_value ? content.sangria_current_cashier_value : null
        i.sangria_out_type_value = content.sangria_out_type_value ? content.sangria_out_type_value : null
        i.sangria_deservacao_value = content.sangria_deservacao_value ? content.sangria_deservacao_value : null
        i.value_close_cashier_input = content.value_close_cashier_input ? content.value_close_cashier_input : null
        i.func_response = content.func_response ? content.func_response : null
        i.value_open_cashier = content.value_open_cashier ? content.value_open_cashier : null
        i.value_bleed_cashier = content.value_bleed_cashier ? content.value_bleed_cashier : null
        i.value_close_cashier = content.value_close_cashier ? content.value_close_cashier : null

        return i
    }
}

class TemplateMountCloseCashier {
    /** @type {TemplateMountParams} */
    params
    htmlString = ''
    /** @type {Document} */
    html
    hasItems
    items = null
    constructor(data, hasItems, items = null) {
        this.items = items
        this.htmlString = html.default
        this.html = new DOMParser().parseFromString(this.htmlString, 'text/html')

        this.setParams(data, hasItems)
        this.reMountHtml()
        this.valid()
    }

    mountTable(items) {
        let itensTable = Object.values(items)
        var context = document.createElement('table');
        context.className = 'table';
        var header = context.createTHead();
        row = header.insertRow();
        var th = document.createElement('th')
        th.innerHTML = 'Forma de pagamento'
        row.appendChild(th)
        var th = document.createElement('th')
        th.innerHTML = 'Valor Pagamento'
        row.appendChild(th)

        var body = context.appendChild(document.createElement('tbody'))
        let total = 0
        for (var i = 0; i < itensTable.length; i++) {
            let item = itensTable[i]
            total += parseFloat(item.value_form_of_payment)
            var row;
            row = body.insertRow();
            row.insertCell().innerHTML = item.form_of_description;
            row.insertCell().innerHTML = item.value_form_of_payment;
        };
        row = body.insertRow();
        row.insertCell().innerHTML = "TOTAL";
        row.insertCell().innerHTML = total.toString();
        context.appendChild(body);
        document.body.appendChild(context);
        return context
    }

    setParams(param, hasItems) {
        this.params = TemplateMountParams.instance(param, hasItems)
    }

    byId(id = '', val = '') {
        id, val
        this.html.getElementById(id).innerHTML = val
        return this.html
    }
    hide(id = '') {
        let el = this.html.getElementById(id)
        if (el) el.hidden = true
    }
    setHtmlString(path = null) {
        if (!path) path = this.path
    }

    padString(str = '') {
        return str.padEnd(22, ".") + ':';
    }
    createEl(str) {
        let el = document.createElement('div')
        el.innerHTML = this.padString(str)
        // el.innerHTML = this.padString(str.title.toUpperCase())

        let subel = document.createElement('span')
        subel.innerHTML = str.value
        el.appendChild(subel)
        return el
    }
    /**
    * @param {HTMLDivElement} el
    * @param {HTMLDivElement} str
    */
    appendByTag(el, str) {
        el.appendChild(str)
    }

    /**
     * @param {[]} items 
     */
    makeItems(items) {
        let value = Object.values(items)
        let i = value.map((e) => this.createEl(e))
        let el = this.html.getElementById('items')
        i.forEach(e => this.appendByTag(el, e))
    }
    reMountHtml() {
        let boy = this.html
        this.hide('customSangria')
        if (this.params.hasItems) {
            this.hide('sangriaOK')
            this.makeItems(this.items)
        } else {
            this.hide('customSangria')
        }
        boy = this.byId('title_value', this.params.title_value)
        boy = this.byId('enterprise_name', this.params.enterprise_name)
        boy = this.byId('info_address', this.params.info_address)
        boy = this.byId('info_address2', this.params.info_address2)
        boy = this.byId('cep_value', this.params.cep_value)
        boy = this.byId('cnpj_value', this.params.cnpj_value)
        boy = this.byId('ie_value', this.params.ie_value)
        boy = this.byId('doc_value', this.params.doc_value)
        boy = this.byId('date_value', this.params.date_value)
        boy = this.byId('moviment_value', this.params.moviment_value)
        boy = this.byId('sangria_in_value', this.params.sangria_in_value)
        boy = this.byId('sangria_pdv_value', this.params.sangria_pdv_value)
        boy = this.byId('sangria_current_cashier_value', this.params.sangria_current_cashier_value)
        boy = this.byId('sangria_out_type_value', this.params.sangria_out_type_value)
        boy = this.byId('sangria_deservacao_value', this.params.sangria_deservacao_value)
        boy = this.byId('value_close_cashier_input', this.params.value_close_cashier_input)
        boy = this.byId('func_response', this.params.func_response)
        boy = this.byId('note_title_value', this.params.note_title_value)
        boy = this.byId('value_open_cashier', this.params.value_open_cashier)
        boy = this.byId('value_bleed_cashier', this.params.value_bleed_cashier)
        boy = this.byId('value_close_cashier', this.params.value_close_cashier)
        let tableHtml = this.mountTable(this.items)
        boy = this.byId('table', tableHtml.outerHTML)

        this.html = boy
    }
    valid() {
        let context = this
        let arr = ['title_value',
            'enterprise_name',
            'note_title_value',
            'info_address',
            'info_address2',
            'cep_value',
            'cnpj_value',
            'ie_value',
            'doc_value',
            'date_value',
            'moviment_value',
            'sangria_in_value',
            'sangria_pdv_value',
            'sangria_current_cashier_value',
            'sangria_out_type_value',
            'sangria_deservacao_value',
            'money_value',
            'func_response',]
        arr.forEach(function (key) {
            if (!context.params[key]) {
                context.hide(`${key}_`)
            }
        })
    }
    static instance(content = {}, hasItems, items) {

        return new TemplateMountCloseCashier(content, hasItems, items);
    }
}
module.exports = {
    TemplateMountParams,
    TemplateMountCloseCashier,
}
